import { render } from "./SuccessModal.vue?vue&type=template&id=6ad1b4a6"
import script from "./SuccessModal.vue?vue&type=script&lang=js"
export * from "./SuccessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/SuccessModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ad1b4a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ad1b4a6', __exports__)) {
    api.reload('6ad1b4a6', __exports__)
  }
  
  module.hot.accept("./SuccessModal.vue?vue&type=template&id=6ad1b4a6", () => {
    api.rerender('6ad1b4a6', render)
  })

}


export default __exports__